import { createFileRoute } from "@tanstack/react-router";

import { legalRoute } from "./legal/-components/legalRoute";

export const Route = createFileRoute("/intellectual-property")(
  legalRoute("intellectual-property")
);
